import { Component, Input } from '@angular/core';

@Component({
  selector: 'loan-card',
  templateUrl: './loan-card.component.html'
})
export class LoanCardComponent {

  @Input() name: string;
  @Input() loanId: string;
  @Input() address: string;

}
